import React from "react";
import styled from "styled-components";
import Table from "../../Table";
import { connect } from "react-redux";
import { getChannels } from "../../../redux/actions/messengerActions";
import Avatar from "@material-ui/core/Avatar";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import MemberAvatar from "../../../views/client/MemberAvatar";
const ChannelsWrapper = styled.div`
  height: 100%;
`;
function Channels(props) {
  const columns = [
    {
      id: "image",
      Header: "Bild",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          <Link to={`/messenger/${props.original._id}`}>
            {props.original.member && (
              <MemberAvatar
                src={props.original.member.profile.picture}
                alt={props.original.member.profile.name}
                online={props.original.member.online}
              />
            )}
          </Link>
        </React.Fragment>
      ),
    },
    {
      id: "name",
      Header: "Kunden ",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          <Link to={`/messenger/${props.original._id}`}>
            {props.original.lastMessageSeen === true ? (
              <span>
                {props.original.member && props.original.member.username}
              </span>
            ) : (
              <strong>
                {props.original.member && props.original.member.username}
              </strong>
            )}
          </Link>
        </React.Fragment>
      ),
    },
    {
      id: "in",
      Header: "IN",
      accessor: (d) => d._id,
      Cell: (props) => <React.Fragment>{props.original.in}</React.Fragment>,
    },
    {
      id: "lastAction",
      Header: "Last Action",
      accessor: (d) => d._id,
      Cell: (props) => <Moment>{props.original.updatedAt}</Moment>,
    },
    {
      id: "out",
      Header: "Out",
      accessor: (d) => d._id,
      Cell: (props) => <React.Fragment>{props.original.out}</React.Fragment>,
    },
    {
      id: "profile",
      Header: "Profile",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          {props.original.user && props.original.user.username}
        </React.Fragment>
      ),
    },
    {
      id: "profileImage",
      Header: "Profile image ",
      accessor: (d) => d._id,
      Cell: (props) => (
        <React.Fragment>
          {props.original.user && (
            <Avatar
              src={props.original.user.profile.picture}
              alt={props.original.user.profile.name}
            />
          )}
        </React.Fragment>
      ),
    },
  ];

  const { channels, data, loading } = props.messenger;
  const { user } = props.auth;
  return (
    <ChannelsWrapper>
      <Table
        data={channels}
        columns={columns}
        loading={loading}
        page={!data.pagination ? 0 : data.pagination.current - 1}
        pages={!data.pagination ? 1 : data.pagination.total}
        onFetchData={(state) => {
          var queryString = state.filtered
            .map((key) => key.id + "=" + key.value)
            .join("&");
          let query = `?page=${state.page + 1}&chatterId=${
            user._id
          }&notwaiting=false&${queryString}`;
          props.getChannels(query);
        }}
        noDataText="No active dialogues"
      />
    </ChannelsWrapper>
  );
}
const mapStateToProps = (state) => ({
  messenger: state.messenger,
  auth: state.auth,
});

export default connect(mapStateToProps, { getChannels })(Channels);
